import { Injectable } from '@angular/core';
import { Route, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { AuthFacade } from '../../auth/services/auth.facade';
import { UsersFacade } from '../services/users.facade';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard {
	constructor(
		private authFacade: AuthFacade,
		private usersFacade: UsersFacade
	) {}

	canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
		return this.usersFacade.getLoggedUser$().pipe(
			switchMap(() => {
				const isTokenExpired = this.authFacade.isAccessTokenExpired();

				if (isTokenExpired) {
					this.authFacade.logout();

					return of(false);
				}

				return of(true);
			}),
			catchError(() => {
				this.authFacade.logout();

				return of(false);
			}),
			take(1)
		);
	}
}
